import { ICON__flask_solid } from '@/assets/icons_fa';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_navigate_ud } from '@/hooks/_base/use_navigate_ud';
import { use_slice_generation } from '@/hooks/store/use_slices';
import { CONTEXT_MENU_ITEM__field_base } from '@/pages/page_generation/sidebar/_base/context_menu/_base/CONTEXT_MENU_ITEM__field_base';
import { HOOK_IMAGE__get_graph_source } from '@/pages/page_generation/sidebar/_base/context_menu/image/HOOK_IMAGE__get_graph_source';
import { REMOTE__generation_create } from '@/state/generation/entity/REMOTE__generation_create';
import { LOCAL__generation_set_current } from '@/state/generation/LOCAL__generation_set_current';
import { assert_false, assert_string_object_id_not_empty } from '@shared/asserts/utils_asserts';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { DTO_REQUEST__generation_create } from '@shared/dto/generation/_requests/DTO_REQUEST__generation_create';

interface PROPS {
  image_asset: DTO__image_asset;
}

export function CONTEXT_MENU_ITEM__image__show_source({ image_asset }: PROPS) {
  const dispatch = use_dispatch();
  const navigate = use_navigate_ud();

  /*
   *
   */

  const { generation_current } = use_slice_generation(['generation_current']);

  const { graph_source } = HOOK_IMAGE__get_graph_source(image_asset);

  /*
   *
   */
  async function onClick() {
    assert_false(graph_source.is_stub());

    graph_source.set_graph_id(ENUM__string_id_empty.OBJECT_ID);
    graph_source.hash_clear();

    let request = new DTO_REQUEST__generation_create();
    request.generation_id_previous = ENUM__string_id_empty.OBJECT_ID;
    request.graph = graph_source;
    request.user_task_id = generation_current.user_task_id;

    let action_result = await dispatch(REMOTE__generation_create(request));

    if (typeof action_result.payload != 'string') return;

    let generation_id = action_result.payload;
    assert_string_object_id_not_empty(generation_id);

    dispatch(LOCAL__generation_set_current(generation_id));

    await navigate(ENUM__page_type.BUILD_PATH_GENERATION(generation_id));
  }

  if (graph_source.is_stub()) return null;
  if (image_asset.is_single_color) return null;

  return <CONTEXT_MENU_ITEM__field_base Icon={ICON__flask_solid} text={'Show source'} on_click={onClick} />;
}
